import { useField, useFormikContext } from 'formik';

import styled from '@emotion/styled';

import {
  FieldErrorInfo,
  IInputField,
  Input,
  InputContainer,
  InputLabel,
  InputWrapper,
  LeftPlaceHolderCardIcon,
  RightPlaceHolderCardIcon,
} from './FormField';

export const WrappedNumberOnlyInputField: React.FC<
  IInputField & { maxLength?: number }
> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  maxLength,
  onValueChange,
  // apiKey,
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext<any>();

  const handleChange = (e: any) => {
    const { value } = e.target;

    if (/^\d*$/.test(value)) {
      // Check if maxLength is specified and enforce the limit
      if (maxLength && value.length > maxLength) {
        return; // Don't update if exceeding max length
      }
      setFieldValue(props.name, value);
      if (onValueChange) {
        onValueChange(value, props.name);
      }
    } else if (value === '') {
      setFieldValue(props.name, value);
      if (onValueChange) {
        onValueChange(value, props.name);
      }
    }
  };

  return (
    <InputWrapper className={className}>
      <WrappedInputLabel htmlFor={props.name || props.id}>
        {label}
      </WrappedInputLabel>
      <InputContainer>
        <WrappedInput
          {...field}
          {...props}
          value={field?.value ?? ''}
          onChange={(e) => handleChange(e)}
        />
        {lpiSrc ? <LeftPlaceHolderCardIcon alt='icon' src={lpiSrc} /> : null}
        {rpiSrc ? <RightPlaceHolderCardIcon alt='icon' src={rpiSrc} /> : null}
      </InputContainer>
      {meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error.capitalize()}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export default WrappedNumberOnlyInputField;

const WrappedInputLabel = styled(InputLabel)`
  color: #6b7280;
  font-weight: 600;
  font-size: 12px;
`;

const WrappedInput = styled(Input)`
  color: #6e7079;
  font-weight: 600;

  &::placeholder {
    font-weight: 600;
  }
`;
